import React from "react";

import { Badge, Icon, PlainButton } from "@culturehq/components";
import { useProfile, useQueryString } from "app/context";
import { ProfileLink } from "app/links";
import { getQueryStringKey, Trans } from "app/utils";
import AnnouncementLink from "app/links/AnnouncementLink";

import QuickOptions from "components/display/QuickOptions";
import LazyEditorOutput from "components/editor/LazyEditorOutput";
import PinUserActivityToggle from "components/feed/feed-item/PinUserActivityToggle";
import Flag from "components/common/Flag";
import { getIcon } from "constants/tagsTypes";

import FeedItemTitle from "./FeedItemTitle";

const AnnouncementCreated = ({ item, onUserActivityUpdate }) => {
  const { profile } = useProfile();
  const { onToggleQueryStringValue } = useQueryString();

  const user = item.users[0];
  const announcement = item.entity;

  const handleTagClick = tag => {
    onToggleQueryStringValue(getQueryStringKey(tag.entityType), tag.entity.id);
  };

  return (
    <div className="FeedItem__preview__announcement_created">
      <FeedItemTitle item={item} date={item.bumpedAt}>
        {profile.organizationAdmin && (
          <QuickOptions>
            <ul className="dropdown-menu">
              <li>
                <AnnouncementLink announcement={announcement}>
                  <Icon icon="eye" />
                  <Trans>View this featured content</Trans>
                </AnnouncementLink>
              </li>
              <li>
                <PinUserActivityToggle
                  userActivity={item}
                  onUserActivityUpdate={onUserActivityUpdate}
                />
              </li>
              <li>
                <Flag action="flagAnnouncement" options={{ announcementId: announcement.id }}>
                  {onTrigger => (
                    <PlainButton onClick={onTrigger}>
                      <Icon icon="ios-flag" />
                      <Trans>Flag featured content as inappropriate</Trans>
                    </PlainButton>
                  )}
                </Flag>
              </li>
            </ul>
          </QuickOptions>
        )}
        <h3 className="FeedItem__title">
          <ProfileLink user={user} />{" "}
          <Trans>created new featured content: {announcement.title}</Trans>
        </h3>
      </FeedItemTitle>
      <LazyEditorOutput output={announcement.body} showTags={false} />
      <div className="chq-ffd-tags">
        {(announcement.announcementTags.length > 0)
          && announcement.announcementTags.map(tag => tag.entity && (
            <Badge key={tag.id} onClick={() => handleTagClick(tag)}>
              <Icon icon={getIcon(tag.entityType)} className="category-icon" />
              {tag.entity.name}
            </Badge>
          ))}
      </div>
    </div>
  );
};

export default AnnouncementCreated;
